import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconHd$1 = /*@__PURE__*/ proxyCustomElement(class WppIconHd extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-hd", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M6.30556 6.88889C6.62772 6.88889 6.88889 7.15006 6.88889 7.47222V9.61111H8.44444V7.47222C8.44444 7.15006 8.70561 6.88889 9.02778 6.88889C9.34994 6.88889 9.61111 7.15006 9.61111 7.47222V12.5278C9.61111 12.8499 9.34994 13.1111 9.02778 13.1111C8.70561 13.1111 8.44444 12.8499 8.44444 12.5278V10.7778H6.88889V12.5278C6.88889 12.8499 6.62772 13.1111 6.30556 13.1111C5.98339 13.1111 5.72222 12.8499 5.72222 12.5278V7.47222C5.72222 7.15006 5.98339 6.88889 6.30556 6.88889ZM11.3611 6.88889C11.0389 6.88889 10.7778 7.15006 10.7778 7.47222V12.5278C10.7778 12.8499 11.0389 13.1111 11.3611 13.1111H12.1389C13.5349 13.1111 14.6667 11.9794 14.6667 10.5833V9.41667C14.6667 8.02061 13.5349 6.88889 12.1389 6.88889H11.3611ZM11.9444 11.9444V8.05556H12.1389C12.8906 8.05556 13.5 8.66495 13.5 9.41667V10.5833C13.5 11.3351 12.8906 11.9444 12.1389 11.9444H11.9444ZM3 5.52778C3 4.13172 4.13172 3 5.52778 3H14.4722C15.8683 3 17 4.13172 17 5.52778V14.4722C17 15.8683 15.8683 17 14.4722 17H5.52778C4.13172 17 3 15.8683 3 14.4722V5.52778ZM5.52778 4.16667C4.77606 4.16667 4.16667 4.77606 4.16667 5.52778V14.4722C4.16667 15.2239 4.77606 15.8333 5.52778 15.8333H14.4722C15.2239 15.8333 15.8333 15.2239 15.8333 14.4722V5.52778C15.8333 4.77606 15.2239 4.16667 14.4722 4.16667H5.52778Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-hd-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-hd", "wpp-icon-hd-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-hd-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-hd-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconHd$1);
      }
      break;
  } });
}

const WppIconHd = WppIconHd$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconHd, defineCustomElement };
